import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'

import DownloadsContainer from 'Common/components/downloads/DownloadsContainer'
import { PageSkeleton } from 'Common/components/skeletons'

export const Route = createFileRoute('/mydownloads')({
    component: () => (
        <Suspense fallback={<PageSkeleton variant="grid" wrapper="main" />}>
            <DownloadsContainer />
        </Suspense>
    ),
})
